import _ from 'lodash';
import { getUserId } from './login';

export const getCurrentUser = (context) => {
  const userId = getUserId(context);
  return getUserById(context, userId);
};

export const getUserById = (context, id) => {
  const users = Object.values(_.get(context, 'entities.users'));
  return users.find((u) => u.Id === id);
};
